import { useEffect, useSyncExternalStore } from "react";

import { CommunicationPreferenceFormType, Nullable } from "@simplyk/common";

export interface CommunicationPreferencesDraft {
  formId: string;
  formType: CommunicationPreferenceFormType;
  selectedContactListIds: string[];
  questionTitle: Nullable<string>;
}

let currentDraft: CommunicationPreferencesDraft | null = null;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((listener) => listener());
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
const getSnapshot = () => currentDraft;
const getServerSnapshot = () => null;

export const useCommunicationPreferencesDraft = (
  formId: string,
  formType: CommunicationPreferenceFormType
): CommunicationPreferencesDraft | null => {
  const draft = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return draft?.formId === formId && draft.formType === formType ? draft : null;
};

export const usePublishCommunicationPreferencesDraft = (draft: CommunicationPreferencesDraft | null) => {
  // Syncs the unsaved edits to the store the previews read, and clears them when the modal closes.
  useEffect(() => {
    if (!draft) {
      return;
    }
    currentDraft = draft;
    notify();
    return () => {
      currentDraft = null;
      notify();
    };
  }, [draft]);
};
